/** How many days the dashboard's revenue-and-growth chart covers. Matches the prototype's copy. */
export const TIMESERIES_DAYS = 30;

/** Sampled from the series for the chart's x-axis, mirroring the prototype's five labels. */
export const X_AXIS_LABEL_COUNT = 5;
